import clsx from 'clsx';
import {
  Button, CodeIcon, Input, Typography,
} from '@aisales/react-ui-kit';
import HelpText from '@pages/entrance/components/HelpText';
import React from 'react';
import { withStyles } from '@material-ui/core';
import IMask from 'imask';
import HeaderWithCircleIcon from '@pages/entrance/components/Registration/components/HeaderWithCircleIcon';
import { Code } from '@material-ui/icons';
import PhoneVerificationV2 from '@components/PhoneVerificationV2';

const masked = IMask.createMask({
  mask: '+0 000 000 00 00',
  // ...and other options
});

const formatValue = (value) => masked.resolve(value);

const EntranceRegistrationSecondStep = ({
  classes, phoneConfirmationCode, setPhoneConfirmationCode, phoneNumber, timeTillNextCode, submitPhone, submitCode, setStep,
}) => (
  <div>
    <div className={clsx(classes.center, classes.hint)}>
      <HeaderWithCircleIcon
        icon={<CodeIcon />}
        text={(
          <div>
            Введи код подтверждения высланный на номер
            <br />
            {' '}
            {formatValue(phoneNumber)}
          </div>
)}
        title="Код подтверждения"
      />
      <PhoneVerificationV2
        phoneConfirmationCode={phoneConfirmationCode}
        setPhoneConfirmationCode={setPhoneConfirmationCode}
        timeTillNextCode={timeTillNextCode}
        submitPhone={submitPhone}
        submitCode={submitCode}
      />
      <HelpText linkText="Вернуться назад" className={classes.secondStep__helpText__returnBack} onClick={() => { setStep(0); }} />

    </div>
  </div>
);

const styles = () => ({
  secondStep__step2Buttons__buttonOneMoreTime: {
    paddingLeft: '36px',
    paddingRight: '36px',
    marginRight: '20px',

  },
  element_marginBottom20: {
    marginBottom: '20px',
    width: '100%',
  },
  center: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    textAlign: 'center',
  },
  hint: {
    marginBottom: '40px',
  },
  secondStep__helpText_code: {
    marginTop: '5px',
  },
  codeInput: {
    marginTop: '20px',
    width: '100%',
    '& div:nth-of-type(2)': {
      width: '100%',
    },
    '& div:nth-of-type(1)': {
      textAlign: 'left',
    },
  },
  secondStep__helpText_countdown: {
    marginTop: '10px',
    width: '100%',
    textAlign: 'left',
  },
  element__horizontallyAlignedButtons: {
    width: '100%',
    display: 'flex',
    justifyContent: 'space-between',
  },
  secondStep__step2Buttons: {
    marginTop: '30px',
  },
  secondStep__step2Buttons__button: {
    width: '190px',
  },
  secondStep__helpText__returnBack: {
    marginTop: '40px',
  },
});

export default withStyles(styles)(EntranceRegistrationSecondStep);
